<template>
  <div>
    <CountStorageHeader :img_header="header_image" header="รายละเอียดการนับสต๊อก" link_back="stock/count_warehouse/countlistwarehouse"/>
    <Warehouse_detail/>
  </div>
</template>

<script>
import CountStorageHeader from "@/components/admin/stock/count_storage/headercount_storage/CountStorageHeader";
import Warehouse_detail from "@/components/admin/stock/count_storage/Warehouse_detail";
import HeaderImage from "@/assets/checklist.png";
export default {
  name: "WarehouseDetail",
  components: {
    Warehouse_detail,
    CountStorageHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
